import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import Spinner from "@cloudscape-design/components/spinner"; // Import the spinner component
import { VehicleMasterTable } from "./data list vehicle/data";

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface StatusVehicleProps {
  vehicles: VehicleMasterTable[] | null; // Allow null for initial state
   // Add a prop for loading status
}

const StatusVehicle: React.FC<StatusVehicleProps> = ({ vehicles }) => {
  const data: DataItem[] = React.useMemo(() => {
    if (!vehicles) return []; // Return empty array if vehicles data is not available

    const statusCount: { [key: string]: number } = {
      Active: 0,
      Inactive: 0,
    };

    vehicles.forEach(vehicle => {
      if (vehicle.Status) {
        statusCount["Active"] += 1;
      } else {
        statusCount["Inactive"] += 1;
      }
    });

    const dataArray: DataItem[] = Object.keys(statusCount).map(title => ({
      title,
      value: statusCount[title],
      percentage: 0,
    }));

    const total = dataArray.reduce((acc, item) => acc + item.value, 0);

    dataArray.forEach(item => {
      item.percentage = Math.round((item.value / total) * 100);
    });

    return dataArray;
  }, [vehicles]);

  const total = data.reduce((acc, item) => acc + item.value, 0);

  
  

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Vehicle Status</h3>
      <PieChart
        data={data}
        visibleSegments={data}
        ariaDescription="Donut chart showing vehicle statuses."
        ariaLabel="Donut chart"
        hideFilter
        hideTitles
        hideLegend
        innerMetricDescription="total units"
        innerMetricValue={total.toString()}
        size="small"
        variant="donut"
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
            <Button>Clear filter</Button>
          </Box>
        }
      />
    </div>
  );
};

export default StatusVehicle;
